import React from 'react';
import { toast } from 'sonner';
import { Facebook, Twitter, Linkedin, Instagram, Music2, Mail, LinkIcon } from 'lucide-react';
import { Button } from '../ui/button';

export const SocialShare = ({ product, url }) => {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const title = product?.name ? `${product.name}` : 'Check this out';
  const shareText = product?.name ? `Check out: ${product.name}` : 'Check this out';

  const open = (shareLink) => window.open(shareLink, '_blank', 'noopener,noreferrer');

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied to clipboard');
    } catch {
      toast.error('Could not copy the link');
    }
  };

  const handleShare = async (platform) => {
    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedText = encodeURIComponent(shareText);

    switch (platform) {
      case 'facebook':
        open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
        return;

      case 'twitter':
        open(`https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`);
        return;

      case 'linkedin':
        open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`);
        return;

      case 'email':
        window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${shareText}\n\n${shareUrl}`)}`;
        return;

      case 'instagram':
        await copyLink();
        toast.success('Link copied. Paste it on Instagram');
        open('https://www.instagram.com/');
        return;

      case 'tiktok':
        await copyLink();
        toast.success('Link copied. Paste it on TikTok');
        open('https://www.tiktok.com/');
        return;

      case 'copy':
      default:
        await copyLink();
        return;
    }
  };

  return (
    <div className="flex items-center flex-wrap gap-2">
      <Button variant="outline" size="icon" onClick={() => handleShare('facebook')} title="Facebook">
        <Facebook className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('twitter')} title="Twitter/X">
        <Twitter className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('linkedin')} title="LinkedIn">
        <Linkedin className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('instagram')} title="Instagram">
        <Instagram className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('tiktok')} title="TikTok">
        <Music2 className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('email')} title="Share via Email">
        <Mail className="w-4 h-4" />
      </Button>

      <Button variant="outline" size="icon" onClick={() => handleShare('copy')} title="Copy link">
        <LinkIcon className="w-4 h-4" />
      </Button>
    </div>
  );
};
